import { type InboxEntry, ResolutionEvidenceKind } from '@this+that/models';

import { useLoadEntryDetailOnce } from './useLoadEntryDetailOnce';
import {
  getCurrentResolutionEvidence,
  resolveCurrentFlag,
} from '../../utils/resolutionEvidence';

export type ResolutionEvidenceEntry = Pick<
  InboxEntry,
  | 'id'
  | 'resolvedAt'
  | 'resolutionSuggestedAt'
  | 'autoResolvedSuggestionAt'
  | 'resolutionEvidence'
>;

const RESOLUTION_EVIDENCE_SCOPE = 'resolution-evidence';
const RESOLUTION_EVIDENCE_ERROR_LABEL = 'Error loading resolution evidence:';
const KEY_PREFIX_BY_KIND: Record<ResolutionEvidenceKind, string> = {
  [ResolutionEvidenceKind.LOOKS_RESOLVED]: 'looks',
  [ResolutionEvidenceKind.AUTO_RESOLVED]: 'auto',
};

const resolveEvidenceKey = (entry: ResolutionEvidenceEntry): string => {
  if (getCurrentResolutionEvidence(entry)) return '';
  const flag = resolveCurrentFlag(entry, { requireAutoStamp: true });
  return flag ? `${KEY_PREFIX_BY_KIND[flag.kind]}:${flag.stamp}` : '';
};

// Lists and WebSocket frames carry no evidence, so it is fetched once per flag or auto-close;
// an empty or failed fetch is not retried for the same stamp.
export function useLoadResolutionEvidence(
  entry: ResolutionEvidenceEntry,
  { enabled = true }: { enabled?: boolean } = {},
) {
  const key = enabled ? resolveEvidenceKey(entry) : '';
  return useLoadEntryDetailOnce(entry.id, key, {
    scope: RESOLUTION_EVIDENCE_SCOPE,
    errorLabel: RESOLUTION_EVIDENCE_ERROR_LABEL,
  });
}
